import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { relatorioAction, fazendaAction } from '../_actions';

export const ModalAnimaisPartos = ({ openModalAnimaisPartos, handleCloseModalAnimaisPartos, props }) => {
    const [fazendaSelecionada, setFazendaSelecionada] = useState(0);
    const dispatch = useDispatch();
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');

    useEffect(() => {
        setFazendaSelecionada(0);
        setDataInicio('');
        setDataFim('');
        const data = new Date();
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        setDataFim(`${ano}-${mes}-${dia}`);
    }, [openModalAnimaisPartos]);

    useEffect(() => {
        if (openModalAnimaisPartos) {
            dispatch(fazendaAction.getFazendaSelect());
        }
    }, [openModalAnimaisPartos]);

    const handleValidationDatas = () => {
        let valid = true;
        let errors = '';

        if (!fazendaSelecionada) {
            valid = false;
            errors += '<li style="float:left;">Informe uma fazenda!</li><br>';
        }

        if (!dataInicio) {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de in&iacute;cio!</li><br>';
        }

        if (!dataFim) {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de t&eacute;rmino!</li><br>';
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de valida&ccedil;&atilde;o',
                showCloseButton: true,
                showConfirmButton: true,
                html: `<div style="font-size: 14px; text-align: left"><ul>${errors}</ul></div>`
            });
        }
        return valid;
    };

    const handleSelectChange = (prop) => (event) => {
        if (prop === 'id_fazenda') {
            setFazendaSelecionada(event.value);
        }
    };

    const renderOptionsFazenda = () => {
        return props.fazenda.fazenda.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const handleGeraRelatorioPartos = () => {
        if (handleValidationDatas()) {
            const { match: { params } } = props;

            let payload = {
                id: params.id,
                id_fazenda: fazendaSelecionada,
                data_inicio: dataInicio,
                data_termino: dataFim,
                tipo_relatorio: "PA"
            };

            console.log('payload', payload)

            dispatch(relatorioAction.getRelatorio(payload, true));
        }
    };


    return (
        <div>
            <Modal isOpen={openModalAnimaisPartos} onClose={handleCloseModalAnimaisPartos} aria-labelledby="form-dialog-title">
                <ModalHeader id="form-dialog-title">Gerar relat&oacute;rio de Partos</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label className="left" for="selecionarFazenda">Selecione uma fazenda: *</Label>
                                {openModalAnimaisPartos &&
                                    <Select
                                        classNamePrefix="select"
                                        value={renderOptionsFazenda().filter(function (option) {
                                            return option.value === (fazendaSelecionada || 0);
                                        })}
                                        onChange={handleSelectChange('id_fazenda')}
                                        isSearchable
                                        placeholder="Selecione..."
                                        id="id_fazenda"
                                        name="id_fazenda"
                                        options={renderOptionsFazenda()}
                                    />
                                }
                                <Row className="mt-1">
                                    <Col>
                                        <Label className="left" for="data_inicio">Data de in&iacute;cio: *</Label>
                                        <Input
                                            id="data_inicio"
                                            label="Data de início *"
                                            className="form-control"
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            value={dataInicio}
                                            onChange={(e) => setDataInicio(e.target.value)}
                                        />
                                    </Col>
                                    <Col>
                                        <Label className="left" for="data_fim">Data de fim: *</Label>
                                        <Input
                                            id="data_fim"
                                            label="Data de término *"
                                            className="form-control"
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            value={dataFim}
                                            onChange={(e) => setDataFim(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleCloseModalAnimaisPartos} color="secondary">Cancelar</Button>
                    <Button onClick={handleGeraRelatorioPartos} color="primary">Gerar relat&oacute;rio</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}